<template lang="pug">
    v-container(grid-list-lg)
        v-layout.hidden-xs-only(row wrap)
            v-flex(xs12)
                div.title

                    // Title
                    slot(name="title")

        v-layout.mb-5(row wrap)
            v-flex(xs12 sm3)

                // Navigation
                navigation

            v-flex.hidden-sm-and-up(xs12)
                div.title

                    // Title
                    slot(name="title")

            v-flex(xs12 sm9)
                div.contentWrapper

                    // Content
                    slot
</template>

<script>
    import Navigation from './Navigation';

    export default {
        components: {
            Navigation
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .contentWrapper
        width: 100%
        background: rgba(255, 255, 255, 0.12)
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.1)
        border-radius: 10px
        padding: 32px 16px 16px
        margin-bottom: 80px

    .title
        margin: 20px 0 32px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .title
            margin: 15px 0 22px
</style>
